import { make } from 'vuex-pathify';
import axios from "axios";
import { triggerError } from "@/components/helpers/error-handler";
import Pusher from "pusher-js";

const timeout = 600000; //10 minutes

const getDefaultState = () => {
  return {
    downloads: [],
    downloadsUpdated: null,
    socket: null
  }
}

const state = getDefaultState();

const mutations = {
  ...make.mutations(state),
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  connectSocket (state, { socket }) {
    state.socket = socket;
  },
  store_downloads(state, {data, time}) {
    state.downloads = data;
    state.downloadsUpdated = time;
  },
};

const actions = {
  async getDownloadList({ state, commit }, { force }) {
    try {
      const time = new Date().getTime();

      if (!force && state.developmentsUpdated && time - state.developmentsUpdated < timeout) {
        return true;
      }

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "downloads"
      });

      commit('store_downloads', { data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  async requestBills({ dispatch }, { developmentRef, billIds, creditIds }) {
    try {
      await axios({
        url: process.env.VUE_APP_API_URL + "downloads/request-bills",
        data: { developmentRef, billIds, creditIds },
        method: "POST"
      });

      dispatch('getDownloadList', { force: true });
      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  async requestMeterData({ dispatch }, { endpointRef, from, to, allReads, selectedUnits, allUnits }) {
    try {
      await axios({
        url: process.env.VUE_APP_API_URL + "downloads/request-meter-data",
        data: { endpointRef, from, to, allReads, selectedUnits, allUnits },
        method: "POST"
      });

      dispatch('getDownloadList', { force: true });
      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  disconnectSocket ( { state } ) {

    if (state.socket !== null) {
      state.socket.disconnect();
    }
  },
  async connectSocket ({ state, commit, dispatch, rootState }) {

    if (state.socket !== null) {
      return;
    }
    const socket = await new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER,
    });

    commit('connectSocket', { socket });

    const channel = socket.subscribe('cli-' + rootState.auth.user.reference);

    await channel.bind('new-download', (data) => {
      dispatch("getDownloadList", { force: true });
      dispatch("notification/triggerSuccess", { detail: data.message, title: "New download available" }, {root: true})
    });
  },
  resetDownloadState ({ commit, dispatch }) {
    dispatch('disconnectSocket')
    commit('resetState')
  },
}

const getters = {
  ...make.getters(state)
};

export const downloads = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
